import { gql } from '@apollo/client';

export const GET_FUNDER_ORGANISATION_ADD_ONS = gql`
  query GetFunderOrganisationAddOns($input: FilterArgs) {
    addOns: funderOrganisationAddOns(input: $input) {
      id
      name
    }
  }
`;
